export const TRANSITION_TIME = {
	FASTEST: 100,
	FASTER: 200,
	FAST: 300,
	REGULAR: 400,
	SLOW: 500,
	SLOWER: 600,
	SLOWEST: 700,
};

export const SIZE_GRID = [
	'0',
	'var(--size-grid001)',
	'var(--size-grid002)',
	'var(--size-grid003)',
	'var(--size-grid004)',
	'var(--size-grid005)',
	'var(--size-grid006)',
	'var(--size-grid007)',
	'var(--size-grid008)',
	'var(--size-grid009)',
	'var(--size-grid010)',
	'var(--size-grid011)',
	'var(--size-grid012)',
	'var(--size-grid013)',
	'var(--size-grid014)',
	'var(--size-grid015)',
	'var(--size-grid016)',
	'var(--size-grid017)',
	'var(--size-grid018)',
	'var(--size-grid019)',
	'var(--size-grid020)',
	'var(--size-grid021)',
	'var(--size-grid022)',
	'var(--size-grid023)',
	'var(--size-grid024)',
];

export const ONEHUB_SIZE = {
	NAVIGATION_TOP_BAR_HEIGHT: '64px',
};
